import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="section-container">
        <div className="section-inner max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 font-heading">
              {t('faq_title')}
            </h2>
          </div>

          <div className="space-y-3">
            {faqItems.map((faq, idx) => {
              const isOpen = openIdx === idx;
              return (
                <div
                  key={idx}
                  className={`rounded-lg border transition-all ${
                    isOpen
                      ? 'bg-background-50 border-primary-200'
                      : 'bg-background-50 border-background-200/70 hover:border-background-300/60'
                  }`}
                >
                  <button
                    onClick={() => setOpenIdx(isOpen ? null : idx)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-semibold text-foreground-950 pr-4 text-sm md:text-base">
                      {t(faq.qKey)}
                    </span>
                    <i
                      className={`ri-${isOpen ? 'subtract' : 'add'}-line flex-shrink-0 text-lg text-primary-500 transition-transform`}
                    />
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-4 animate-fade-in">
                      <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                        {t(faq.aKey)}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}